<mds-appbar
    [profile]="profile$ | async"
    [logo]="'medpace-color-light'"
    [hideItems]="['help', 'menu', 'study-select', 'search', 'app-switch']"
    [actionItems]="actionItems"
    [notificationItems]="(notifications$ | async) ?? []"
    [disableItems]="['help', 'menu', 'study-select', 'search', 'app-switch']"
    [title]="''"
    (logoutEventEmitter)="logout()"
    [logoutDialogAppName]="applicationName"
    [ngClass]="displaySideBar() ? '' : 'hide-icons'"
    [sortStudyFilteredOptions]="false"
>
    <mds-icon-button
        [icon]="'menu'"
        (clickEvent)="globalSidenav.toggle(); resizeFooter()"
        [tooltip]="''"
        [ngClass]="displaySideBar() ? '' : 'hidden'"
    ></mds-icon-button>
</mds-appbar>
@if (isLoading$ | async) {
    <medpace-loading />
}

<mds-global-sidenav-container style="display: flex; width: 100%; height: 100%; z-index: 100; box-sizing: border-box">
    <!-- [isOpenOnPageLoad]="false" - footer is glitching when sidenav is open on page load - probably mds bug, we decided to close the sidenav by default -->
    <mds-global-sidenav
        [ngClass]="displaySideBar() ? '' : 'hidden'"
        id="mds-global-sidenav-panel"
        [isOpenOnPageLoad]="false"
        #globalSidenav
    >
        <mds-global-sidenav-options
            [routerLinkActiveOptions]="{ exact: true }"
            [sideNavOptions]="sidenavActions$ | async"
        />
    </mds-global-sidenav>

    <mds-global-sidenav-content>
        @if (isRouterOutputLoad()) {
            <router-outlet></router-outlet>
        }
    </mds-global-sidenav-content>
</mds-global-sidenav-container>
